module.exports = __webpack_public_path__ + "static/36-c3a6b31e427957d7f97b0e1b4fffa876.jpg";